// tutorial: esponiamo i metodi per le notifiche a popup (toat)
import toastr from 'toastr';
import '@/../node_modules/toastr/build/toastr.css';

let notificationEnabled = true;

export function flagNotificationEnabled(flag: boolean) {
    notificationEnabled = flag;
}

export function err(message: string) {
    if (notificationEnabled) {
        toastr.error(message);
    }
}

export function success(message: string) {
    if (notificationEnabled) {
        toastr.success(message);
    }
}
